import React from 'react';
import FamilyCard from './FamilyCard';

const body = [
  'Dr. Elena Vasquez built the first stable quantum processor in a Zurich basement in 2025. By 2071, she had produced the first quantum consciousness upload — her own. She would live, in quantum form, for over <strong class="text-white">five centuries</strong>, present at the founding of the First Collective, the construction of the Helios Array, and the commissioning of the Odyssey in 2514.',
  'Her descendants spread across the solar system: to Mercury\'s crystal refinement labs, to Jupiter\'s volcanic mining stations, to the Belt\'s silent freighters. The Vasquez name became shorthand for the Awakening itself — a synonym for the moment the universe cracked open.',
  'She delivered the mission address at the Odyssey\'s commissioning before returning — for the last time — to a biological body, then dissolving it peacefully. Five centuries of life, folded quietly into the dark.',
];

const FamilyVasquez = () => (
  <FamilyCard
    id="family-0"
    accentColor="text-amber-400"
    dotColor="bg-amber-400"
    borderColor="border-amber-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-amber-900/10 via-transparent to-transparent"
    tag="The Spark · Earth / Zurich → Solar System"
    name="The Vasquezes"
    origin="Earth · Zurich · The Solar System"
    role="The Spark"
    body={body}
    quote="I could not have imagined any of you. But I can tell you this: I have lived long enough to know that wisdom is not the same thing as certainty."
    quoteSource="Elena Vasquez, commissioning address of the Odyssey, 2514"
  />
);

export default FamilyVasquez;